module.exports = __webpack_public_path__ + "static/media/level1_q2.727f494c.png";